import React, { useState } from "react";
import { Box } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { callAPIInterface } from "../constants";
import {
  applyPromo,
  loadingMsg,
  promoCode,
  promoCodePlaceholder,
  promoCodeSubheader,
  submit,
} from "../messages";
import Text from "../text/Text";
import { Input } from "../input/Input";
import CustomDivider from "../divider/Divider";
import Button from "../button/Button";
import BackdropLoader from "../backdropLoader/BackdropLoader";
import CommonHeader from "../CommonHeader";
import { useSession } from "../../hooks/useSession";

const ApplyPromoCodeSettings = () => {
  const navigate = useNavigate();
  const { session } = useSession();

  const [inputPromoCode, setInputPromoCode] = useState(null);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const accountCountry = session?.account?.account?.country;

  const handleKeyDown = (e) => {
    if (e.keyCode === 13) {
      handleApply();
    }
  };

  const handleApply = async () => {
    setIsSubmitting(true);
    const apiData = {
      name: inputPromoCode,
      account_type: "Wallet",
      avail_on: "SETTINGS",
      country_code: accountCountry,
    };
    callAPIInterface("POST", "/promo-code/apply", JSON.stringify(apiData))
      .then((res) => {
        callAPIInterface("GET", `/promo-code/${res.promo_code_id}`).then(
          (response) => {
            navigate("/promo-code-success", { state: { details: response } });
          }
        );
      })
      .catch((err) => {
        console.error(err);
      })
      .finally(() => {
        setIsSubmitting(false);
      });
  };

  return (
    <>
      <BackdropLoader
        open={isSubmitting}
        alt={loadingMsg}
        text={loadingMsg}
        customClass="loading-in-auth"
      />
      <CommonHeader textAfterIcon={applyPromo} icon="backArrow" />
      <Box className="options-container">
        <Box className="apply-promo-code-wrapper">
          <Box
            className="module-container"
            display="flex"
            flexDirection="column"
            gap={2}
          >
            <Box className="module-container-content">
              <Text
                size={16}
                font="regular"
                className="grey-text mb-10"
                textAlign="left"
              >
                {promoCodeSubheader}
              </Text>
              <Input
                fullWidth
                showLabel
                label={promoCode}
                placeholder={promoCodePlaceholder}
                name="promo_code"
                value={inputPromoCode}
                onChange={(e) => {
                  setInputPromoCode(e.target.value);
                }}
                onKeyDown={handleKeyDown}
              />
            </Box>
            <Box className="module-container-footer">
              <CustomDivider className="settings-divider" />
              <Button
                fullWidth
                type="submit"
                variant="contained"
                label={submit}
                onClick={handleApply}
                disabled={!inputPromoCode}
              />
            </Box>
          </Box>
        </Box>
      </Box>
    </>
  );
};

export default ApplyPromoCodeSettings;
